import Vue from "vue";
import MessageBox from "./MessageBox.vue";

let Constructor = Vue.extend(MessageBox);

let instance;
let instances = [];
let seed = 1;

const CMessageBox = function(options) {
  if (Vue.prototype.$isServer) return;
  options = options || {};
  if (typeof options === "string") {
    options = {
      message: options
    };
  }
  let id = "messagebox_" + seed++;

  instance = new Constructor({
    data: options
  });
  instance.id = id;

  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;
  instances.push(instance);
  // return instance.vm;
  return new Promise(resolve => {
    instance.vm.resolve = resolve;
  });
};

["alert", "confirm"].forEach(type => {
  CMessageBox[type] = options => {
    if (typeof options === "string") {
      options = {
        message: options
      };
    }
    options.type = type;
    return CMessageBox(options);
  };
});

CMessageBox.close = function(id) {
  for (let i = 0, len = instances.length; i < len; i++) {
    if (id === instances[i].id) {
      instances.splice(i, 1);
      break;
    }
  }
};

CMessageBox.closeAll = function() {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].close();
  }
};

export default CMessageBox;
